import http from "./http";
export default {
    scheme: "https",
    domainHost: http.domainHost,
    parse: http.parse,
    serialize: http.serialize
};
//# sourceMappingURL=https.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/uri-js/dist/esnext/schemes/https.js
// module id = 1580
// module chunks = 0